import React, { useState } from 'react';
import VolontarLogo from '../../assets/svg/volontar_logo_white.svg';
import CheckSvg from '../../assets/svg/check-circle-outline.svg';
import Store from 'eas-react-store';
import { useTranslation } from 'react-i18next';

function ForgotPassword(props) {
    const { t } = useTranslation();
    const [email, setEmail] = useState(props.location.state != null ? props.location.state.email : '');
    const [isSuccess, setIsSuccess] = useState(false);

    const changePassword = async (event) => {
        event.preventDefault();

        if (email !== '') {
            props.store.User.askToChangePassword(email);

            setIsSuccess(true);
        }
    };

    return (
        <div className="login-page create-password">
            <div className="header"></div>
            <header>
                <img
                    src={VolontarLogo}
                    alt="Logo in white of Volontär App"
                />
            </header>

            <div className="container">
                <div className="organisation">
                    {isSuccess &&
                        <img className="check-success" src={CheckSvg} alt="" />
                    }

                    <h1 className="organisation-title">
                        {! isSuccess ? t('forgotPassword.findAccount') : <span><b>{t('forgotPassword.done')}</b><br/>{t('forgotPassword.checkEmail')}</span>}
                    </h1>

                    {isSuccess &&
                        <a href="/" className="button-login button-show">
                            {t('forgotPassword.goBack')}
                        </a>
                    }

                    {! isSuccess &&
                        <form className="form-login">
                            <div className="input-container">
                                <input
                                    className={`field-is-alone`}
                                    type="email"
                                    name="email"
                                    value={email}
                                    placeholder={t('login.emailAddress')}
                                    onChange={(event) => {
                                        setEmail(event.target.value)
                                    }}
                                />
                            </div>

                            <button className="button-login button-show" onClick={changePassword}>
                                {t('forgotPassword.continue')}
                            </button>
                        </form>
                    }
                </div>
            </div>
        </div>
    );
}

export default Store.connectStore(ForgotPassword);
